

import React, { useState, useEffect, useRef } from "react";
import useHttp from "../../../../hooks/use-http";
import { toast } from "react-toastify";

const OrganizationConfigurationsForm = (props) => {
  const [orgId, setOrgId] = useState("");
  const [orgData, setOrgData] = useState([]);
  const [configSettings, setConfigSettings] = useState([]);

  const { sendRequest: getOrg } = useHttp();
  const { sendRequest: getOrgConfigs } = useHttp();

  const settingRefs = useRef([]);

  useEffect(() => {
    getOrg(
      {
        url: `/api/organisation/`,
      },
      (res) => {
        if (res) setOrgData(res);
      }
    );
  }, []);

  useEffect(() => {
    if (orgId) {
      fetchConfigSettings(orgId);
    } else {
      setConfigSettings([]);
    }
  }, [orgId]);

  const fetchConfigSettings = (orgId) => {
    getOrgConfigs(
      {
        url: `/api/orgconfigsForApplication/?orgId=${orgId}`,
      },
      (data) => {
        if (data) {
          setConfigSettings(data);
        }
      }
    );
  };

  const handleOrgChange = (e) => {
    setOrgId(e.target.value);
  };

  const handleCheckboxChange = (index) => {
    setConfigSettings((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              status: item.status === 1 ? 0 : 1,
              settingValue: item.status === 1 ? item.defaultValue : item.settingValue,
            }
          : item
      )
    );
  };

  const handleInputChange = (index, value) => {
    setConfigSettings((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, settingValue: value } : item
      )
    );
  };

  const { sendRequest: postOrgPermissions } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const data = configSettings.map((item) => ({
      ...item,
      orgId,
      createdBy: parseInt(localStorage.getItem("id")),
      settingValue: item.hasValue ? item.settingValue : "",
    }));

    postOrgPermissions(
      {
        url: "/api/orgconfigapplications/",
        method: "POST",
        body: data,
      },
      (data) => {
        props.addForm(false);
        toast.success("Organization Permissions Updated");
      }
    );
  };

  useEffect(() => {
    if (props.update && props.update.orgId) {
      setOrgId(props.update.orgId);
      fetchConfigSettings(props.update.orgId); // Fetch config settings for the selected organization
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">
                    Organization Services Permissions Form
                  </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-1"></div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Organization Name</label>
                        <select
                          className="form-control"
                          value={orgId}
                          onChange={handleOrgChange}
                          required
                        >
                          <option value="">Select</option>
                          {orgData.map((x) => (
                            <option key={x.orgId} value={x.orgId}>
                              {x.orgName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Configuration Settings Table */}
                  {configSettings.length > 0 && (
                    <div className="row">
                      <div className="col-md">
                        <table className="table table-bordered text-center">
                          <thead>
                            <tr>
                              <th>Configuration Name</th>
                              <th>Enable</th>
                              <th>Setting Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            {configSettings.map((item, index) => (
                              <tr key={item.orgConfigSettingId}>
                                <td>{item.orgConfigSettingName}</td>
                                <td>
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={item.status === 1} // Checkbox is controlled by status
                                    onChange={() => handleCheckboxChange(index)}
                                    ref={(el) =>
                                      (settingRefs.current[index] = el)
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={item.settingValue} // Retains value even if checkbox is unchecked
                                    onChange={(e) =>
                                      handleInputChange(index, e.target.value)
                                    }
                                    disabled={!item.hasValue} // Disabled only when hasValue is false
                                    ref={(el) =>
                                      (settingRefs.current[index + "input"] =
                                        el)
                                    }
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  <hr />

                  <div className="text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default OrganizationConfigurationsForm;